import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixEcomOrdersInvoicesV1InvoicesUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/ecom/v1/bulk/invoices',
        destPath: '/v1/bulk/invoices',
      },
      {
        srcPath: '/ecom/v1/invoices',
        destPath: '/v1/invoices',
      },
      {
        srcPath: '/ecom/v1/ep-invoices',
        destPath: '/v1/invoices',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/ecom/v1/ep-invoices',
        destPath: '/v1/invoices',
      },
      {
        srcPath: '/_api/ecom-payments/v1/invoices',
        destPath: '/v1/invoices',
      },
    ],
    _: [
      {
        srcPath: '/v1/invoices',
        destPath: '/v1/invoices',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/ecom/v1/invoices',
        destPath: '/v1/invoices',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ecom_order-invoices';

/**
 * Retrieves the IDs of invoices associated with all specified orders.
 *
 *
 * The `listInvoicesForSingleOrder()` function returns a Promise that resolves when the specified order's transaction records are retrieved.
 */
export function listInvoicesForMultipleOrders(
  payload: object
): RequestOptionsFactory<any> {
  function __listInvoicesForMultipleOrders({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.orders.v1.invoice',
      method: 'POST' as any,
      methodFqn:
        'com.wix.ecom.orders.invoices.v1.Invoices.ListInvoicesForMultipleOrders',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixEcomOrdersInvoicesV1InvoicesUrl({
        protoPath: '/v1/invoices/list-by-ids',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __listInvoicesForMultipleOrders;
}

/** Generates and adds an invoice to a specified order. */
export function generateInvoice(payload: object): RequestOptionsFactory<any> {
  function __generateInvoice({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.orders.v1.invoice',
      method: 'POST' as any,
      methodFqn: 'com.wix.ecom.orders.invoices.v1.Invoices.GenerateInvoice',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixEcomOrdersInvoicesV1InvoicesUrl({
        protoPath: '/v1/invoices/orders/{orderId}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __generateInvoice;
}

/** Generates and adds invoices to all specified orders. */
export function bulkGenerateInvoices(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkGenerateInvoices({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.orders.v1.invoice',
      method: 'POST' as any,
      methodFqn:
        'com.wix.ecom.orders.invoices.v1.Invoices.BulkGenerateInvoices',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixEcomOrdersInvoicesV1InvoicesUrl({
        protoPath: '/v1/bulk/invoices/generate',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkGenerateInvoices;
}

/** Adds an invoice to a specified order. */
export function addInvoiceToOrder(payload: object): RequestOptionsFactory<any> {
  function __addInvoiceToOrder({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.orders.v1.invoice',
      method: 'POST' as any,
      methodFqn: 'com.wix.ecom.orders.invoices.v1.Invoices.AddInvoiceToOrder',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixEcomOrdersInvoicesV1InvoicesUrl({
        protoPath: '/v1/invoices/orders/{orderId}/add-invoice',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __addInvoiceToOrder;
}
